import { useMutation, useQueryClient } from '@tanstack/react-query';
import { produce } from 'immer';

import { GET_SEO_QUERY_KEY } from './useGetSeo';

import SeoService, { SeoResponse, UpdateSeoDto } from '@/services/SeoService';

export function useUpdateSeo() {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: (updateSeoConfigDto: UpdateSeoDto) =>
      SeoService.updateSeoConfig(updateSeoConfigDto),
    onMutate: (updateSeoDto) => {
      const previousData =
        queryClient.getQueryData<SeoResponse>(GET_SEO_QUERY_KEY);

      queryClient.setQueryData<SeoResponse>(
        GET_SEO_QUERY_KEY,
        produce((draft) => ({
          ...draft,
          ...updateSeoDto,
        })),
      );

      return { previousData };
    },
    onError: (_error, _updateSeoDto, context) => {
      queryClient.setQueryData<SeoResponse>(
        GET_SEO_QUERY_KEY,
        context?.previousData,
      );
    },
    onSuccess: (data) => {
      queryClient.setQueryData<SeoResponse>(GET_SEO_QUERY_KEY, data);
    },
  });

  return {
    updateSeo: mutateAsync,
    isLoading: isPending,
  };
}
